import { parseMimeType } from '@scalar/helpers/http/mime-type';
import { unpackProxyObject } from '@scalar/workspace-store/helpers/unpack-proxy';
import { serializeFormPropertyWithEncoding } from './serialize-form-property.js';
/**
 * Named multipart arrays produce one part per item, using the same property name.
 * Encoding applies to each item, including its content type. Without an explicit
 * style, nested arrays remain individual JSON values instead of expanding again.
 *
 * @see https://spec.openapis.org/oas/v3.2.0.html#encoding-by-name
 */
export const serializeMultipartArray = (key, value, encoding) => {
    if (!Array.isArray(value)) {
        return null;
    }
    const hasStyle = encoding?.style !== undefined || encoding?.explode !== undefined || encoding?.allowReserved !== undefined;
    const contentType = hasStyle ? undefined : encoding?.contentType;
    return value.flatMap((item) => {
        const parts = serializeFormPropertyWithEncoding(key, item, encoding);
        if (parts) {
            return parts;
        }
        if (item instanceof File) {
            return [{ key, value: unpackProxyObject(item), ...(contentType ? { contentType } : {}) }];
        }
        const structured = typeof item === 'object' && item !== null;
        const itemContentType = contentType ?? (!hasStyle && structured ? 'application/json' : undefined);
        const subtype = itemContentType ? parseMimeType(itemContentType).subtype : undefined;
        const isJson = subtype === 'json' || subtype?.endsWith('+json');
        return [
            {
                key,
                value: structured || isJson ? JSON.stringify(unpackProxyObject(item)) : String(item),
                ...(itemContentType ? { contentType: itemContentType } : {}),
            },
        ];
    });
};
